import { FapBaseModel } from '../../base/fap-base-model';


export class PlanTypeModel extends FapBaseModel {
    public static fields: Array<string> = [
        'id',
        'name',
        'name_t',
        'color',
        'icon',
        'entity_form'
    ];

    public static requiredFields: Array<string> = [
        'id',
    ];

    public static extendedFields: {} = {
    };

    public id: number;
    public name: string;
    public nameT: string;
    public color: string;
    public icon: any;
    public entityForm: number;
}
